<div class="module-home-container" [class.layout-compact]="layout === 'compact'">
  <nb-card class="main-card" *ngIf="layout === 'default'">
    <nb-card-header class="card-header-custom">
      <div class="header-content">
        <div class="header-title">
          <nb-icon [icon]="headerIcon" class="header-icon"></nb-icon>
          <h4>{{ pageTitle }}</h4>
        </div>
      </div>
    </nb-card-header>
    <nb-card-body class="card-body-custom">
      <div class="selecao-intro">
        <nb-icon [icon]="headerIcon" class="intro-icon"></nb-icon>
        <h5>{{ introTitle }}</h5>
        <p>{{ introText }}</p>
      </div>
      <ng-container *ngTemplateOutlet="gridContent"></ng-container>
    </nb-card-body>
  </nb-card>

  <ng-container *ngIf="layout === 'compact'">
    <ng-container *ngTemplateOutlet="gridContent"></ng-container>
  </ng-container>
</div>

<ng-template #gridContent>
  <div class="nav-cards-grid" *ngIf="items.length; else emptyState">
    <button
      type="button"
      class="nav-card"
      *ngFor="let item of items; trackBy: trackByTitle"
      (click)="navigate(item)"
      [attr.aria-label]="'Acessar ' + item.title">
      <span class="nav-card__icon">
        <nb-icon [icon]="item.icon"></nb-icon>
      </span>
      <span class="nav-card__title">{{ item.title }}</span>
      <span class="nav-card__meta" *ngIf="layout !== 'compact'">
        <nb-icon icon="arrow-forward-outline"></nb-icon>
        <span>Acessar</span>
      </span>
    </button>
  </div>

  <ng-template #emptyState>
    <div class="nav-cards-empty">
      <nb-icon icon="alert-circle-outline"></nb-icon>
      <p>Nenhuma funcionalidade disponível para seu perfil.</p>
    </div>
  </ng-template>
</ng-template>
